import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

import * as thunk from './thunk';

export const initialState = {
    companyList:[],
    error: {},
    loading: true
};

const CompanySlice = createSlice({
    name: 'Company',
    initialState,
    reducers: {},
    extraReducers: builder => {

        // <--------------------------- getCompany --------------------------->
        builder.addCase(thunk.getCompany.fulfilled, (state, action) => {
            state.companyList = action.payload;
            state.loading = true;
        });
        builder.addCase(thunk.getCompany.rejected, (state, action) => {
            state.error = action?.error || {};
        });
    }
});

export default CompanySlice.reducer;